module.exports = __webpack_public_path__ + "img/base_activites_pique_nique.6e7bb3bc.svg";